import BaseModel from '../../core/baseModel';

export default BaseModel.extend({
  defaults: {
    col1: {
      items: []
    },
    col2: {
      show: false,
      name: undefined,
      items: []
    },
    col3: {
      show: false,
      items: []
    },
    formAction: undefined
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc1/fttc1ViewModel.js
 **/